import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";
import Button from "../../components/Button";
import LanguageSwitcher from "../../components/LanguageSwitcher";
import { T, panelStyle } from "../../components/admin/theme";
import { ADMIN_MODULES } from "./modules";

export default function AdminLayout() {
  const { t, i18n } = useTranslation();
  const { user, logout } = useAuth();
  const location = useLocation();
  const active = ADMIN_MODULES.find((item) => location.pathname.includes(`/admin/${item.path}`))?.id || "overview";

  return (
    <div style={{ minHeight: "100vh", background: T.bg, color: T.night, fontFamily: "'DM Sans',sans-serif" }}>
      <header style={{ background: `linear-gradient(135deg,${T.night},${T.royal})`, color: T.white, padding: "18px clamp(16px,4vw,48px)", display: "flex", gap: 16, alignItems: "center", justifyContent: "space-between", flexWrap: "wrap" }}>
        <div>
          <strong style={{ fontSize: 22 }}>ReturnOb</strong>
          <div style={{ fontSize: 12, opacity: .8 }}>{t("admin.console")}</div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <span>{user?.firstName} · {t(`admin.roles.${user?.role}`, { defaultValue: user?.role })}</span>
          <LanguageSwitcher />
          <Button size="sm" variant="ghost" onClick={logout}>{t("admin.logout")}</Button>
        </div>
      </header>
      <main style={{ maxWidth: 1240, margin: "auto", padding: "clamp(20px,4vw,40px)" }}>
        <div className="admin-layout" style={{ display: "grid", gridTemplateColumns: "220px minmax(0,1fr)", gap: 24 }}>
          <nav aria-label={t("admin.navigation")} style={panelStyle}>
            {ADMIN_MODULES.map((item) => (
              <NavLink
                key={item.id}
                to={item.path}
                style={({ isActive }) => ({
                  display: "block", width: "100%", textAlign: "left", textDecoration: "none",
                  borderRadius: 10, padding: 12, fontWeight: 700,
                  color: isActive ? T.white : T.night,
                  background: isActive ? T.royal : "transparent",
                })}
              >
                <span style={{ marginRight: 10 }}>{item.icon}</span>{t(`admin.modules.${item.id}`)}
              </NavLink>
            ))}
          </nav>
          <section>
            <h1 style={{ marginTop: 0 }}>{t(`admin.modules.${active}`)}</h1>
            <p style={{ color: T.muted }}>{t(`admin.descriptions.${active}`)}</p>
            <Outlet context={{ locale: i18n.language }} />
          </section>
        </div>
      </main>
      <style>{"@media(max-width:720px){.admin-layout{grid-template-columns:1fr!important}.admin-layout nav{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:4px}.admin-table{font-size:12px}.admin-table td,.admin-table th{padding:8px!important}}"}</style>
    </div>
  );
}
